import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import HmsPageHero from "./components/HmsPageHero";
import HmsIntroSection from "./components/HmsIntroSection";
import HmsAdvantagesSection from "./components/HmsAdvantagesSection";
import HmsHowItWorksSection from "./components/HmsHowItWorksSection";
import HmsUserRolesSection from "./components/HmsUserRolesSection";
import HmsModulesSection from "./components/HmsModulesSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import HmsCtaBanner from "./components/HmsCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "./hospital-management.css";

const HospitalManagementPage: React.FC = () => {
  useEffect(() => {
    document.title =
      "Hospital Management System | WebTech Software Solutions Bangalore";
    const description =
      "WebTech develops automated hospital management software in Bangalore — admin, doctors, patients, nurses, pharmacists, lab technicians, and more in one platform.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page hms-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HmsPageHero />
            <HmsIntroSection />
            <HmsAdvantagesSection />
            <HmsHowItWorksSection />
            <HmsUserRolesSection />
            <HmsModulesSection />
            <WdevTestimonials />
            <HmsCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HospitalManagementPage;
